module.exports = __webpack_public_path__ + "media/configurations/SO-SX-SX-SX-SX-SO-1c6177fc.png";